import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { ReportTypes } from 'types/transactionsExport'

export const useReportTypeRadioOptions = () => {
  const { t } = useTranslation()
  return [
    {
      label: t('exports.transactions'),
      value: ReportTypes.TRANSACTION,
    },
    {
      label: t('exports.walletBalance'),
      value: ReportTypes.BALANCE,
    },
  ]
}

type CustomDateValue = string | number | dayjs.Dayjs | Date
interface CustomDateOption {
  name: string
  fromDate: CustomDateValue
  toDate: CustomDateValue
}

export interface CustomDateValueOptionsType {
  last30Days: CustomDateOption
  lastMonth: CustomDateOption
  last3Months: CustomDateOption
  customDateRange: CustomDateOption
}

interface CustomDateRadioOptionsType {
  label: string
  value: string
  secondaryLabel?: string
}

const todaysDate = dayjs()

const last30Days = todaysDate.subtract(30, 'day')

const getStartDateOfXMonth = (lastXMonthsNumericValue: 1 | 3): dayjs.Dayjs => {
  return todaysDate.subtract(lastXMonthsNumericValue, 'month').startOf('month')
}

const endOfLastMonth = todaysDate.subtract(1, 'month').endOf('month')

export const customDateValueOptions = (
  from?: CustomDateValue,
  to?: CustomDateValue
): CustomDateValueOptionsType => {
  return {
    last30Days: {
      name: 'last30Days',
      fromDate: last30Days.format('YYYY-MM-DD'),
      toDate: todaysDate.format('YYYY-MM-DD'),
    },
    lastMonth: {
      name: 'lastMonth',
      fromDate: getStartDateOfXMonth(1).format('YYYY-MM-DD'),
      toDate: endOfLastMonth.format('YYYY-MM-DD'),
    },
    last3Months: {
      name: 'last3Months',
      fromDate: getStartDateOfXMonth(3).format('YYYY-MM-DD'),
      toDate: endOfLastMonth.format('YYYY-MM-DD'),
    },
    customDateRange: {
      name: 'customDateRange',
      fromDate: dayjs(from).format('YYYY-MM-DD'),
      toDate: dayjs(to).format('YYYY-MM-DD'),
    },
  }
}

export const customDateRadioOptions = (
  csvExportCustomDateOption: CustomDateValueOptionsType
): CustomDateRadioOptionsType[] => {
  const { t } = useTranslation()
  return [
    {
      label: t('exports.dateOptions.last30Days'),
      value: csvExportCustomDateOption.last30Days.name,
      secondaryLabel: `${last30Days.format('MMM DD, YY')} - ${todaysDate.format('MMM DD, YY')}`,
    },
    {
      label: t('exports.dateOptions.lastMonth'),
      value: csvExportCustomDateOption.lastMonth.name,
      secondaryLabel: `${getStartDateOfXMonth(1).format('MMM DD, YY')} - ${endOfLastMonth.format(
        'MMM DD, YY'
      )}`,
    },
    {
      label: t('exports.dateOptions.lastXMonths', { numberOfMonths: 3 }),
      value: csvExportCustomDateOption.last3Months.name,
      secondaryLabel: `${getStartDateOfXMonth(3).format('MMM DD, YY')} - ${endOfLastMonth.format(
        'MMM DD, YY'
      )}`,
    },
    {
      label: t('exports.dateOptions.customDateRange'),
      value: csvExportCustomDateOption.customDateRange.name,
    },
  ]
}

export const exportFormatRadioOptions = () => {
  const { t } = useTranslation()
  return [
    {
      label: t('exports.transactionCsv'),
      value: 'csv',
    },
    {
      label: t('exports.pdfStatement'),
      value: 'pdf',
    },
  ]
}
